export default __webpack_public_path__ + "static/media/golden_arrow_left.63ea8915.svg";